const style = ({ COLORS }) => ({
  title: ({ size }) => ({
    margin: `0 0 ${size(1.6, { scaleFactor: 'sm' })}`,
    color: COLORS.TEXT.OFF_BLACK.NORMAL
  }),
  button: ({ size }) => ({
    fontSize: size(1.4, { scaleFactor: 'sm' })
  }),
  description: ({ size }) => ({
    margin: `${size(3.2)} 0`,
    color: COLORS.TEXT.MID_GREY.NORMAL
  })
})

export default style
